import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";
import {
  getStrategyDashboardI18nKey,
  STRATEGY_DASHBOARD_TABS
} from "../../../../../lib/StrategyDashboard/strategyDashboardConfig";
import { useStrategyDashboardConfig } from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import { Body, H3 } from "../../../common/Typography";
import StrategyDashboardBreadcrumb from "./StrategyDashboardBreadcrumb";
import StrategySignalsTable from "./StrategySignalsTable";

const StrategyDashboardSignalsTab = ({ translate }) => {
  const dashboard = useStrategyDashboardConfig();
  const i18nKey = suffix => getStrategyDashboardI18nKey(dashboard, suffix);

  return (
    <div className="bg-white py-8 -mx-3.6 px-4 md:mx-0 md:px-10 flex flex-col gap-3">
      <div>
        <StrategyDashboardBreadcrumb page={STRATEGY_DASHBOARD_TABS.SIGNALS} />
        <H3 tag="h1" className="mt-4">
          {translate(i18nKey("signals_page_heading"))}
        </H3>
      </div>
      <Body>{translate(i18nKey("signals_page_body"))}</Body>
      {dashboard.signalsTable ? <StrategySignalsTable /> : null}
    </div>
  );
};

export default withTranslations(StrategyDashboardSignalsTab);
